export const ticketStatus = [
  { value: 1, label: "Pendiente", key: "pendiente" },
  { value: 2, label: "Autorizada", key: "autorizada" },
  { value: 3, label: "Pagada", key: "pagada" },
  { value: 4, label: "Cancelada", key: "cancelada" },
];

export const mainTicketStatus = [
  { value: 1, label: "Pendiente" },
  { value: 2, label: "Autorizada" },
  { value: 3, label: "Pagada" },
  { value: 4, label: "Cancelada" },
];

export const ticketObjectStatus = {
  pendiente: 1,
  autorizada: 2,
  pagada: 3,
  cancelada: 4,
};